import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PT1: TStep[] = [
  {
    pageId: PageId.DOG_SEX_PT1,
  },
  {
    pageId: PageId.DOG_AGE_PT1,
  },
  {
    pageId: PageId.SHELTER_PT1,
  },
  {
    pageId: PageId.DOG_BREED_PT1,
  },
  {
    pageId: PageId.URGE_PT1,
  },
  {
    pageId: PageId.STARTED_PT1,
  },
  {
    pageId: PageId.PLACE_PT1,
  },
  {
    pageId: PageId.GOALS_PT1,
  },
  {
    pageId: PageId.ACCIDENTS_PT1,
  },
  {
    pageId: PageId.CONCERNS_PT1,
  },
  {
    pageId: PageId.URGE_2_PT1,
  },
  {
    pageId: PageId.LIVING_SITUATION_PT1,
  },
  {
    pageId: PageId.POTTY_BREAKS_PT1,
  },
  {
    pageId: PageId.CRATE_TRAINING_PT1,
  },
  {
    pageId: PageId.BEHAVIOR_PT1,
  },
  {
    pageId: PageId.COMMANDS_PT1,
  },
  {
    pageId: PageId.TRAINING_TIME_PT1,
  },
  {
    pageId: PageId.PREPARE_FLOW_PT1,
  },
  {
    pageId: PageId.COMMITMENT_SCREEN_PT1,
  },
  {
    pageId: PageId.EMAIL_PT1,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_PT1,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_PT1,
  },
  {
    pageId: PageId.CANCEL_OFFER_PT1,
  },
  {
    pageId: PageId.CHAT_UPSELL_PT1,
  },
  {
    pageId: PageId.UPSELL_PT1,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_PT1,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_PT1,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_PT1,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PT1.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)
